
export default "/assets/numbered-list-micro.d22998fe.svg"